import { Navigate, useLocation } from 'react-router-dom';

import { parseQueryString, setQueryStringMultiple } from 'utils/url';
import { ensurePrefix } from 'utils/string';
import { SCENE } from 'consts/scenes';

type DeeplinkResource = {
  queryParam: string;
  buildUrl: (id: string) => string;
};

const DEEPLINK_RESOURCES: DeeplinkResource[] = [
  {
    queryParam: 'alertId',
    buildUrl: (id) =>
      setQueryStringMultiple(
        {
          view: 'all',
          alert: id,
        },
        SCENE.detections.path,
      ),
  },
  {
    queryParam: 'indicatorId',
    buildUrl: (id) =>
      setQueryStringMultiple(
        {
          r: ensurePrefix(id, 'IND-'),
        },
        SCENE.indicators.path,
      ),
  },
  {
    queryParam: 'eventId',
    buildUrl: (id) =>
      setQueryStringMultiple(
        {
          view: 'intel-events',
          r: ensurePrefix(id, 'EV-'),
        },
        SCENE.detections.path,
      ),
  },
];

const DEFAULT_REDIRECT_PATH = SCENE.alerts.path;

const DeeplinkPage = () => {
  const location = useLocation();
  const params = parseQueryString(location.search);

  for (const resource of DEEPLINK_RESOURCES) {
    const id = params[resource.queryParam];

    if (id && typeof id === 'string') {
      const targetUrl = resource.buildUrl(id);
      return <Navigate to={targetUrl} replace />;
    }
  }

  return <Navigate to={DEFAULT_REDIRECT_PATH} replace />;
};

export default DeeplinkPage;
